"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const isEmpty_1 = __importDefault(require("lodash/isEmpty"));
const mobx_1 = require("mobx");
const verifyCDPOTP_1 = __importDefault(require("../../clients/corporate/verifyCDPOTP"));
const API_STATE_1 = __importDefault(require("../../constants/app/API_STATE"));
const mapInitialStateToStoreState_1 = __importDefault(require("../../utils/store/mapInitialStateToStoreState"));
/**
 * Verify CDP OTP Domain Store
 */
class VerifyCDPOTPStore {
    constructor(initialState) {
        this.data = {};
        this.apiState = API_STATE_1.default.INITIAL;
        this.errorData = {};
        /**
         * Fetches verify CDP OTP data from backend
         * @param errorHandler {function}
         */
        this.fetch = (0, mobx_1.flow)(function* (reqParam, successHandler, errorHandler) {
            try {
                this.apiState = API_STATE_1.default.LOADING;
                this.data = {};
                this.errorData = {};
                const response = yield (0, verifyCDPOTP_1.default)(reqParam);
                this.onSuccess(response, successHandler);
            }
            catch (err) {
                this.onError(err, errorHandler);
            }
        });
        /**
         * on success callback
         * @param data
         */
        this.onSuccess = (data, successHandler) => {
            this.data = data;
            this.apiState = API_STATE_1.default.SUCCESS;
            if (successHandler) {
                successHandler(data); // passes the response object back
            }
        };
        /**
         * on error callback
         * @param err
         * @param errorHandler
         */
        this.onError = (err, errorHandler) => {
            this.apiState = API_STATE_1.default.FAILED;
            // when a request is cancelled, Axios promise is rejected
            if (err.response) {
                const errResponse = err.response;
                const { data, status } = errResponse;
                // stores axios error info in observable
                this.errorData = {
                    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                    // @ts-ignore
                    data,
                    status,
                };
                if (errorHandler) {
                    errorHandler(errResponse);
                }
            }
        };
        /**
         * Map initial state to store state
         * @param initialState
         */
        this.updateInitialState = (initialState) => {
            (0, mapInitialStateToStoreState_1.default)(this, initialState);
        };
        this.updateInitialState(initialState);
    }
    /**
     * Returns the loading status
     * @returns {Boolean}
     */
    get isLoading() {
        return this.apiState === API_STATE_1.default.LOADING;
    }
    /**
     * Returns if API fetch was success
     * @returns {Boolean}
     */
    get isSuccess() {
        return this.apiState === API_STATE_1.default.SUCCESS;
    }
    /**
     * Returns if API fetch has failed
     * @returns {Boolean}
     */
    get hasFailed() {
        return this.apiState === API_STATE_1.default.FAILED;
    }
    /**
     * Returns true if OTP is verified succesfully
     */
    get isOtpVerified() {
        return !(0, isEmpty_1.default)(this.data) && this.isSuccess;
    }
}
__decorate([
    mobx_1.observable
], VerifyCDPOTPStore.prototype, "data", void 0);
__decorate([
    mobx_1.observable
], VerifyCDPOTPStore.prototype, "apiState", void 0);
__decorate([
    mobx_1.observable
], VerifyCDPOTPStore.prototype, "errorData", void 0);
__decorate([
    mobx_1.computed
], VerifyCDPOTPStore.prototype, "isLoading", null);
__decorate([
    mobx_1.computed
], VerifyCDPOTPStore.prototype, "isSuccess", null);
__decorate([
    mobx_1.computed
], VerifyCDPOTPStore.prototype, "hasFailed", null);
__decorate([
    mobx_1.computed
], VerifyCDPOTPStore.prototype, "isOtpVerified", null);
__decorate([
    mobx_1.action.bound
], VerifyCDPOTPStore.prototype, "onSuccess", void 0);
__decorate([
    mobx_1.action.bound
], VerifyCDPOTPStore.prototype, "onError", void 0);
__decorate([
    mobx_1.action.bound
], VerifyCDPOTPStore.prototype, "updateInitialState", void 0);
exports.default = VerifyCDPOTPStore;
